<template>
  <v-container class="patients-page pa-2 page-layout" fluid>
    <v-row dense>
      <v-col class="py-0">
        <h1 class="page-title">Patient Search</h1>
      </v-col>
    </v-row>

    <v-row v-if="!isFamilyHealthChoiceTenant" dense>
      <v-col cols="12" md="6" lg="4" class="pb-0">
        <v-select
          v-model="insChoice"
          :items="insurances"
          label="Choose Insurance"
          outlined
          dense
          :disabled="insDisabled"
        ></v-select>
      </v-col>
    </v-row>

    <v-row v-if="insChoice.length === 0 && !isFamilyHealthChoiceTenant" dense>
      <v-col class="pt-0 pb-0">
        <v-alert type="info" dense class="py-2">Please select an insurance to continue</v-alert>
      </v-col>
    </v-row>

    <v-row v-else dense class="provider-filters-row">
      <v-col cols="12" sm="6" md="2" lg="3" class="pb-0">
        <v-text-field
          v-model="searchTerm"
          id="patientSearch"
          label="Search Patients"
          placeholder="Name or ID..."
          autofocus
          clearable
          outlined
          dense
          prepend-inner-icon="mdi-magnify"
          @click:clear="clearSearch"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="3" class="pb-0">
        <v-select
          v-model="memberScope"
          :items="memberScopeItems"
          label="Members"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>

    <v-row v-if="insChoice.length > 0" dense>
      <v-col cols="12">
        <v-card flat class="rounded-lg">
          <v-data-table
            :loading="loading"
            :headers="tableHeaders"
            :items="patients"
            :items-per-page="15"
            :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, -1] }"
            :no-data-text="loading ? 'Loading...' : 'No matching patients...'"
            class="patients-table"
            dense
          >
            <template v-slot:item.STATUS="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small :color="getPatientStatus(item)">mdi-circle</v-icon>
                </template>
                <span>{{ getPatientStatusTooltip(item) }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.NAME="{ item }">
              <span class="font-weight-medium">{{ item.NAME }}</span>
            </template>
            <template v-slot:item.ID="{ item }">
              <v-chip small outlined color="secondary">{{ item.ID }}</v-chip>
            </template>
            <template v-slot:item.DOB="{ item }">
              {{ formatDate(item.DOB) }}
            </template>
            <template v-slot:item.PLAN_NAME="{ item }">
              {{ formatPlanName(item.PLAN_NAME || item.GROUP_NAME) || 'N/A' }}
            </template>
            <template v-slot:item.ELIGIBLE_MONTH="{ item }">
              {{ item.ELIGIBLE_MONTH ? formatDate(item.ELIGIBLE_MONTH) : 'N/A' }}
            </template>
            <template v-slot:item.DISENROLLMENT_DATE="{ item }">
              {{ item.DISENROLLMENT_DATE ? formatDate(item.DISENROLLMENT_DATE) : 'N/A' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <patient-modal-fhc v-if="isFamilyHealthChoiceTenant" :patient="item" />
              <patient-modal
                v-else-if="shouldShowPatientModal && !eligibleUser"
                :patient="item"
                :insurance="insChoice"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { debounce } from 'lodash';
import PatientModal from '../components/PatientModal.vue';
import PatientModalFHC from '../components/PatientModalFHC.vue';
import { formatPlanNameForDisplay } from '../utils/planNameDisplay';

export default {
  name: 'patients',
  components: {
    PatientModal,
    'patient-modal-fhc': PatientModalFHC,
  },
  data() {
    return {
      patients: [],
      errors: [],
      searchTerm: '',
      memberScope: 'active',
      memberScopeItems: [
        { text: 'All members', value: 'all' },
        { text: 'Active members only', value: 'active' },
      ],
      loading: true,
      insurances: [],
      insChoice: [],
      groups: [],
      provider: [],
      filterMembers: ['My Members', 'All'],
      selectedFilter: 'My Members',
      eligibleUser: false,
      cancelSource: null,
      user: '',
    };
  },
  mounted() {
    this.getUser();
    this.eligible();
  },
  methods: {
    formatPlanName(val) {
      return formatPlanNameForDisplay(val);
    },
    async checkPresets() {
      if (
        this.user.role === 'Clinical'
        || this.user.role === 'Provider'
        || this.user.role === 'Group'
        || this.user.role === 'Affiliation'
      ) {
        this.setPresets();
      } else {
        // this.getOrgs();
        this.getInsurances();
      }
    },
    async setPresets() {
      this.insurances = this.user.insurance;
      console.log(this.user);

      if (this.user.role === 'Group') {
        await axios.get(`api/list/npi/${this.user.npi}/groups`).then((response) => {
          this.groups = response.data[0].BILLING_PROVIDER_NPI;
        });
        this.insChoice = this.user.insurance[0];
      } else if (this.user.role === 'Provider' || this.user.role === 'Clinical') {
        this.insChoice = this.user.insurance[0];
        this.groups = this.user.group;
        this.provider = this.user.npi;
      } else if (this.user.role === 'Affiliation') {
        await axios.get(`api/list/ipaId/${this.user.npi}/groups`).then((response) => {
          console.log('happens');
          this.insChoice = this.user.insurance[0];
          this.groups = response.data;
        });
      }
    },
    async getUser() {
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
        })
        .catch(err => this.$router.push('/login'));
      this.checkPresets();
    },
    async getInsurances() {
      if (this.isFamilyHealthChoiceTenant) {
        this.insurances = ['FamilyHealthChoice'];
        this.insChoice = 'FamilyHealthChoice';
        return;
      }
      if (this.user.role === 'Admin' || this.user.role === 'Superuser') {
        await axios.get('api/list/insurances').then((response) => {
          this.insurances = response.data;
        });
      }
    },
    async getPatients() {
      this.patients = [];
      this.loading = true;

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      let url = `api/patient/random/${this.insChoice}`;

      await axios
        .get(url, {
          cancelToken: this.cancelSource.token,
          params: this.activeOnly ? { activeOnly: '1' } : {},
        })
        .then((response) => {
        this.patients = response.data;
        this.loading = false;
        this.cancelSource = null;
      });
    },
    async searchForPatient() {
      this.patients = [];
      this.loading = true;
      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();
      let url = `api/patient/search/${this.insChoice}/${this.searchTerm}`;
      await axios
        .get(url, {
          cancelToken: this.cancelSource.token,
          params: this.activeOnly ? { activeOnly: '1' } : {},
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.patients = response.data;
          this.loading = false;
          this.cancelSource = null;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getPatientStatus(patient) {
      if (String(patient.PORTAL_ACCOUNT_STATUS || '').toLowerCase() === 'suspended') return 'error';
      const billing = String(patient.MEMBER_BILLING_BANNER_KIND || 'none');
      if (billing === 'plan_suspended_nonpay') return 'error';
      if (billing === 'payment_grace') return 'warning';
      const today = new Date().toISOString().substring(0, 7);
      const eligible = patient.ELIGIBLE_MONTH ? String(patient.ELIGIBLE_MONTH).substring(0, 7) : null;
      const termed = patient.DISENROLLMENT_DATE ? String(patient.DISENROLLMENT_DATE).substring(0, 7) : null;
      if (!eligible) return 'grey';
      if (!termed) return eligible <= today ? 'success' : 'grey';
      return eligible <= today && termed > today ? 'success' : 'error';
    },
    getPatientStatusTooltip(patient) {
      if (String(patient.PORTAL_ACCOUNT_STATUS || '').toLowerCase() === 'suspended') return 'Account suspended';
      const billing = String(patient.MEMBER_BILLING_BANNER_KIND || 'none');
      if (billing === 'plan_suspended_nonpay') return 'Plan suspended (non-payment)';
      if (billing === 'payment_grace') return 'Payment overdue (grace period)';
      const today = new Date().toISOString().substring(0, 7);
      const eligible = patient.ELIGIBLE_MONTH ? String(patient.ELIGIBLE_MONTH).substring(0, 7) : null;
      const termed = patient.DISENROLLMENT_DATE ? String(patient.DISENROLLMENT_DATE).substring(0, 7) : null;
      if (!eligible) return 'Unknown';
      if (!termed) return eligible <= today ? 'Active' : 'Not yet eligible';
      return eligible <= today && termed > today ? 'Active' : 'Termed';
    },
    async eligible() {
      if (this.user.role === 'Provider') {
        const response = await axios.get(`api/providers/${this.user.npi}`);
        this.eligibleUser = response.data.PCP;
      } else {
        this.eligibleUser = false;
      }
    },
    clearSearch() {
      this.searchTerm = '';
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    formatDate(val) {
      if (!val) return 'N/A';
      const str = String(val).trim();
      const iso = str.includes('T') ? str.split('T')[0] : str.substring(0, 10);
      const parts = iso.split('-').filter(Boolean);
      if (parts.length === 3) return parts[1] + '/' + parts[2] + '/' + parts[0];
      if (parts.length === 2) return parts[1] + '/' + parts[0];
      return iso;
    },
  },
  watch: {
    searchTerm: debounce(async function searchTerm() {
      if ((this.searchTerm == '') | (this.searchTerm == null)) {
        this.getPatients();
      } else {
        this.searchForPatient();
      }
    }, 300),

    async selectedFilter() {
      // Call getPatients whenever selectedFilter changes.
      this.getPatients();
    },
    memberScope() {
      if (this.insChoice === undefined || this.insChoice === null) return;
      if (Array.isArray(this.insChoice) && this.insChoice.length === 0) return;
      const term = (this.searchTerm || '').trim();
      if (term) {
        this.searchForPatient();
      } else {
        this.getPatients();
      }
    },
    async insChoice() {
      if (this.insChoice === undefined) this.insChoice = [];
      else this.getPatients();
    },
    async user() {
      if (this.user === undefined) {
        this.getUser();
      }
    },
  },
  computed: {
    activeOnly() {
      return this.memberScope === 'active';
    },
    isFamilyHealthChoiceTenant() {
      const c = (process.env.VUE_APP_CUSTOMER || '').toLowerCase();
      const ins = (this.insChoice || '').toString().toLowerCase();
      return c === 'familyhealthchoice' || c === 'floridahealthchoice' ||
        ins === 'familyhealthchoice' || ins === 'floridahealthchoice';
    },
    shouldShowPatientModal() {
      return (
        this.user.role === 'Admin'
        || this.user.role === 'Superuser'
        || (this.eligibleUser !== undefined && this.selectedFilter === 'My Members')
      );
    },
    insDisabled() {
      if (this.user.role === 'Provider') {
        return true;
      }
      return false;
    },
    tableHeaders() {
      const h = [
        { text: '', value: 'actions', sortable: false, width: 56, align: 'center' },
        { text: '', value: 'STATUS', sortable: false, width: 40 },
        { text: 'Name', value: 'NAME', sortable: true },
        { text: 'ID', value: 'ID', sortable: true },
        { text: 'DOB', value: 'DOB', sortable: true },
        { text: 'Sex', value: 'SEX', sortable: true },
        { text: 'Plan', value: 'PLAN_NAME', sortable: true },
        { text: 'PCP/Center', value: 'PCP', sortable: true },
        { text: 'Eligible', value: 'ELIGIBLE_MONTH', sortable: true },
        { text: 'Disenrolled', value: 'DISENROLLMENT_DATE', sortable: true },
      ];
      return h;
    },
  },
};
</script>

<style scoped>
.patients-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
.patients-table >>> .v-data-table td,
.patients-table >>> .v-data-table th {
  padding: 8px 16px !important;
}
</style>
